import HTTP from '../HTTP';

const URL_BASE = 'gescom/EcheancierPaiement/';

export async function generationEcheancierPaiement(data) {
  const response = await HTTP.post(URL_BASE + 'GenerationEcheancierPaiementAsync', data);
  return response;
}

export async function updateEcheancierPaiement(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateEcheancierPaiementAsync', params);
  return response;
}
